import { UploadDataType } from '@ebalance/proto/bffuser/v1/csv_upload_history_model_pb'

import { routePaths } from '~/routes/routePaths'

/**
 * データ種別 → 表示名 i18n key (design HTML の 6 種は旧構想で現実装と乖離)。
 */
const DATA_TYPE_LABEL_KEY: Record<UploadDataType, string> = {
  [UploadDataType.UNSPECIFIED]: 'page:adminUploadHistory.dataType.unspecified',
  [UploadDataType.SUPPLY_48_DATA]:
    'page:adminUploadHistory.dataType.supply48Data',
  [UploadDataType.BILATERAL_TRADE]:
    'page:adminUploadHistory.dataType.bilateralTrade',
  [UploadDataType.CIS_CONTRACT]: 'page:adminUploadHistory.dataType.cisContract',
  [UploadDataType.SPOT_BID_NORMAL]:
    'page:adminUploadHistory.dataType.spotBidNormal',
  [UploadDataType.SPOT_BID_BLOCK]:
    'page:adminUploadHistory.dataType.spotBidBlock',
  [UploadDataType.INTRADAY_BID]: 'page:adminUploadHistory.dataType.intradayBid',
  [UploadDataType.CUSTOMER_CONTRACT]:
    'page:adminUploadHistory.dataType.customerContract',
}

export function dataTypeLabelKey(dataType: UploadDataType): string {
  return (
    DATA_TYPE_LABEL_KEY[dataType] ??
    DATA_TYPE_LABEL_KEY[UploadDataType.UNSPECIFIED]
  )
}

/**
 * docs/specs/admin/data/uploads/history.md AC-006: 失敗行の再アップロード
 * リンクの遷移先。 データ種別ごとの専用 CSV アップロード画面へマップする。
 * 未知の種別は undefined。
 */
export function dataTypeUploadRoute(
  dataType: UploadDataType,
): string | undefined {
  switch (dataType) {
    case UploadDataType.SUPPLY_48_DATA:
      return routePaths.adminUploadsSupply48Data.path
    case UploadDataType.BILATERAL_TRADE:
      return routePaths.adminUploadsBilateralTrade.path
    case UploadDataType.CIS_CONTRACT:
      return routePaths.adminUploadsCisContract.path
    case UploadDataType.SPOT_BID_NORMAL:
      return `${routePaths.biddingSpotCsvImport.path}?kind=normal`
    case UploadDataType.SPOT_BID_BLOCK:
      return `${routePaths.biddingSpotCsvImport.path}?kind=block`
    case UploadDataType.INTRADAY_BID:
      return routePaths.biddingIntradayCsvImport.path
    case UploadDataType.CUSTOMER_CONTRACT:
      return routePaths.adminUploadsCustomerContract.path
    default:
      return undefined
  }
}
